/** @type {import('../../../node_modules/htmx.org/dist/htmx.esm.d.ts').htmx} htmx */
import htmx from 'htmx.org';

/**
 * Configured on import rather than from app.js: htmx processes the page at DOMContentLoaded,
 * which can precede every module that imports `t()` while a catalog chunk is loading.
 * @see https://htmx.org/docs/
 */
function setupHtmx() {
    htmx.config.responseHandling = [
        {code: '429', swap: true, select: '#main-content', ignoreTitle: true}, // custom
        {code: '204', swap: false}, // default
        {code: '[23]..', swap: true}, // default
        {code: '[45]..', swap: false, error: true}, // default
    ];

    // Many routes serve a full document and an HTMX fragment from the same URL. On a history
    // cache miss, restore with a real page load rather than asking the server for a fragment
    // and swapping it over the whole body. historyRestoreAsHxRequest is dormant while
    // refreshOnHistoryMiss is true; it guards the load-from-server path if that is ever reverted.
    htmx.config.historyRestoreAsHxRequest = false;
    htmx.config.refreshOnHistoryMiss = true;

    // htmx defaults to serializing DELETE params into the URL query string, which would leak
    // CSRF tokens from @csrf-carrying forms into access logs. Send them as a body like every
    // other non-GET verb.
    htmx.config.methodsThatUseUrlParams = ['get'];

    // `document.startViewTransition()` rejects with an InvalidStateError on a hidden document,
    // and htmx ignores that rejection. Cancelling `htmx:beforeTransition` makes htmx do a plain
    // swap instead, which is what a backgrounded tab needs anyway: nobody sees the animation.
    document.addEventListener('htmx:beforeTransition', (event) => {
        if (document.visibilityState === 'hidden') {
            event.preventDefault();
        }
    });
}

setupHtmx();
